import { useEffect, useMemo, useState } from "react";
import { useAppMutation } from "../../../../hooks/index.js";
import { Button, IndexTable, Spinner, Stack } from "@shopify/polaris";
import { ViewMinor } from "@shopify/polaris-icons";
import UndoButton from "./UndoButton.js";
import { formatDate } from "../../../../utils/formatDate.js";
import { actionTypes } from "../../../../../constants/productActionTypes.js";

const UndoChangesTable = ({ actionId, setProductsIds, handleClose }) => {
  const [actionHistory, setActionHistory] = useState([]);

  const { isLoading: isLoadingHistory, mutate: mutateHistory } = useAppMutation({
    url: "/api/action-history",
    reactMutationOptions: {
      onSuccess(data) {
        setActionHistory(() => data.actionHistory);
      }
    }
  });

  useEffect(() => {
    if (actionId) {
      setActionHistory([]);
      mutateHistory({ actionId });
    }
  }, [actionId]);


  const rowMarkup = useMemo(() => {
    return actionHistory.map((item, index) => {
      return (
        <IndexTable.Row
          id={item.id}
          key={item.id}
          position={index}
        >
          <IndexTable.Cell>
            {index + 1}
          </IndexTable.Cell>
          <IndexTable.Cell>
            {actionTypes[item.productActionType]}
          </IndexTable.Cell>
          <IndexTable.Cell>
            <Stack>
              <span>{item.products.length}</span>
              <Button
                icon={ViewMinor}
                plain
                onClick={() => {
                  setProductsIds(prev => item.products);
                }}
              />
            </Stack>
          </IndexTable.Cell>
          <IndexTable.Cell>
            {formatDate(item.updatedAt)}
          </IndexTable.Cell>
          <IndexTable.Cell>
            <Stack distribution={"trailing"}>
              <UndoButton handleClose={handleClose} historyItem={item} setActionHistory={setActionHistory} />
            </Stack>
          </IndexTable.Cell>
        </IndexTable.Row>
      );
    });
  }, [actionHistory, setProductsIds]);

  return (
    isLoadingHistory
      ? <Stack distribution={"center"}><Spinner /></Stack>
      : <IndexTable
        itemCount={actionHistory.length}
        headings={
          [
            { title: "#" },
            { title: "Action" },
            { title: "Products" },
            { title: "Last Update" },
            { title: "" }
          ]
        }
        selectable={false}
        emptyState={<p>changes not found</p>}
      >
        {rowMarkup}
      </IndexTable>

  );
};

export default UndoChangesTable;
